module.exports = __webpack_public_path__ + "media/images/mailer/logo_transparent-254ba56d6113aac4ad27251c023b399e.png";